module.exports = __webpack_public_path__ + "static/img/email.fbdae51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.png
// module id = 1250
// module chunks = 169